import z from 'zod';

export const ActivityInstanceSchema = z.object({
  application_id: z.string(),
  instance_id: z.string(),
  launch_id: z.string(),
  location: z.object({
    id: z.string(),
    kind: z.enum(['gc', 'pc']),
    channel_id: z.string(),
    guild_id: z.string().optional(),
  }),
  users: z.array(z.string()),
});

export type ActivityInstance = z.infer<typeof ActivityInstanceSchema>;
export class DiscordApiError extends Error {}
export class ActivityInstanceNotFoundError extends Error {}
export class ActivityInstanceParseError extends Error {}
export class ActivityInstanceFetchError extends Error {}
export class ActivityInstanceGuildMismatchError extends Error {}
export class ActivityInstanceChannelMismatchError extends Error {}
export class UserNotConnectedToActivityError extends Error {}
export class UserNotGuildMemberError extends Error {}
export class GuildMembershipApiError extends Error {}
export class GuildMembershipFetchError extends Error {}
export class InsufficientPermissionsError extends Error {}
export class MissingGuildError extends Error {}
export class MissingChannelError extends Error {}
